import React from "react";
import { Button, ConfigProvider } from "antd";
import type { ButtonProps } from "antd";
import { useSelector } from "react-redux";
import { getTenantConfig } from "ee/selectors/tenantSelectors";

interface GradientButtonProps extends Omit<ButtonProps, "type"> {
  children: React.ReactNode;
  onClick: any;
}

const gradientTheme = {
  token: {
    colorBgContainer: "linear-gradient(90deg, #13C2C2 0%, #C5AFFF 100%)",
  },
  components: {
    Button: {
      defaultBg: "linear-gradient(90deg, #13C2C2 0%, #C5AFFF 100%)",
      defaultColor: "#fff",
      defaultHoverColor: "#fff",
    },
  },
};

const GradientButton: React.FC<GradientButtonProps> = ({
  children,
  onClick,
  icon = null,
  ...rest
}) => {
  const tenantConfig = useSelector(getTenantConfig);
  const { brandColors } = tenantConfig;
  return (
    <ConfigProvider theme={{
      token: {
        colorBgContainer: brandColors.primary,
      },
      components: {
        Button: {
          defaultBg: brandColors.primary,
          defaultColor: "#fff",
          defaultHoverColor: "#fff",
        },
      },
    }}>
      <Button type="default" onClick={onClick} icon={icon} {...rest}>
        {children}
      </Button>
    </ConfigProvider>
  );
};

export default GradientButton;
